import React from 'react';
import { metrics } from 'react-metrics';
import config from './metrics/metrics.config';
import App from './App';

/*client side entry point for the app that includes metrics middleware config*/
export default metrics(config, { useTrackBinding: false })(App);
